import { Component, Input } from '@angular/core';
import { TranslatableKey } from '@app/types/translatable.type';
import { ChangeRequestTemplateDisplayOptions } from '@app/types/translatables/change-request-template-display.options';
import { BaseForm } from '@forms/base.form';
import { ApprovalWorkflowStep } from '@models/approvals/approval-workflow-step.model';
import { ApprovalWorkflow } from '@models/approvals/approval-workflow.model';
import { ChangeRequestTemplate } from '@models/change-requests/change-request-template.model';

@Component({
    templateUrl: './request-template-review.form.html',
    selector: 'app-request-template-review-form',
    styleUrls: ['./request-template-review.style.scss'],
})
export class RequestTemplateReviewForm extends BaseForm {
    @Input() changeRequestTemplate: ChangeRequestTemplate;
    @Input() selectedRoleNames: TranslatableKey[] = [];
    @Input() notifySubject = false;
    @Input() approvalWorkflow: ApprovalWorkflow;

    ChangeRequestTemplateDisplayOptions = ChangeRequestTemplateDisplayOptions;

    approverLabel(step: ApprovalWorkflowStep): TranslatableKey {
        switch (step.actor) {
            case 'direct_manager':
                return 'components.change-requests.approver.employeeDirectManager';

            case 'indirect_manager':
                return 'components.change-requests.approver.employeeManagerManager';

            case 'subject':
                return 'components.change-requests.approver.requestSubject';

            case 'specific_employee':
                return step?.employee?.fullName;
            default:
                return '';
        }
    }
}
